import ApiClient from './ApiClient';

class FlowManagerAPI extends ApiClient {
  constructor() {
    super('flow_manager', { accountScoped: true });
  }
}

export default new FlowManagerAPI();
